import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Steps = _resolveComponent("Steps")!
  const _component_tarifauswahl = _resolveComponent("tarifauswahl")!
  const _component_leistungstabelle = _resolveComponent("leistungstabelle")!
  const _component_tarifoptionen = _resolveComponent("tarifoptionen")!
  const _component_validierungs_fehler = _resolveComponent("validierungs-fehler")!
  const _component_Zelle = _resolveComponent("Zelle")!
  const _component_Zeile = _resolveComponent("Zeile")!
  const _component_produktmodul = _resolveComponent("produktmodul")!
  const _component_titel_zelle = _resolveComponent("titel-zelle")!
  const _component_HugRabatt = _resolveComponent("HugRabatt")!
  const _component_maklerrabatt = _resolveComponent("maklerrabatt")!
  const _component_beitrag = _resolveComponent("beitrag")!
  const _component_email_oder_herunterladen = _resolveComponent("email-oder-herunterladen")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Steps, {
      items: _ctx.navItems,
      active: 1,
      onGotoPage: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('goto-page', $event)))
    }, null, 8, ["items"]),
    _createElementVNode("section", null, [
      _createVNode(_component_tarifauswahl, { tarifauswahlInformationen: _ctx.tarifauswahlInformationen }, null, 8, ["tarifauswahlInformationen"]),
      _createVNode(_component_leistungstabelle, {
        inhalt: _ctx.piniaStore.state.isMakler ? _ctx.leistungenMakler : _ctx.leistungenDirekt,
        aktiveLinie: _ctx.aktiveLinie,
        link: _ctx.getTIB()
      }, null, 8, ["inhalt", "aktiveLinie", "link"]),
      _createVNode(_component_tarifoptionen, { tarifoptionInformationen: _ctx.tarifoptionInformationen }, null, 8, ["tarifoptionInformationen"]),
      (_ctx.fehler.vorschaedenAnzahl)
        ? (_openBlock(), _createBlock(_component_Zeile, {
            key: 0,
            spacingY: true
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Zelle, { offset: 3 }, {
                default: _withCtx(() => [
                  _createVNode(_component_validierungs_fehler, {
                    "fehler-text": _ctx.fehler.vorschaedenAnzahl
                  }, null, 8, ["fehler-text"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_produktmodul, {
        produktmodule: _ctx.produktmodule,
        "zeige-icons": true,
        onChange: _cache[1] || (_cache[1] = (id, value) => _ctx.Logger().log('change', id, value))
      }, null, 8, ["produktmodule"]),
      _createVNode(_component_Zeile, { class: "o-grid--align-middle u-mar-t-2" }, {
        default: _withCtx(() => [
          _createVNode(_component_titel_zelle, {
            breite: 3,
            class: "u-form-heading unset-text-align"
          }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [
              _createTextVNode("Rabatt")
            ])),
            _: 1,
            __: [2]
          }),
          _createVNode(_component_HugRabatt)
        ]),
        _: 1
      }),
      _createVNode(_component_maklerrabatt, { fehler: _ctx.fehler }, null, 8, ["fehler"]),
      _createVNode(_component_beitrag, { onNextPage: _ctx.nextPage }, null, 8, ["onNextPage"]),
      _createVNode(_component_email_oder_herunterladen, {
        produkt: "phv2025",
        "tracking-zusatz": "vergleich"
      })
    ])
  ], 64))
}